// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2j8NR","notes":"Notes_notes__2rL3v"};